(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentListControllers', ['services.authenticatedUser',
                                                      'actionPlanModule',
                                                      'governanceProcessModule',
                                                      'riskModule']);
})();
